/* Neyli : zoom optionnel sur l'image principale des fiches produit uniquement.
   - Désactivé par défaut : le visiteur l'active avec le bouton « Activer le zoom » placé sous l'image.
   - Souris (zoom activé) : l'image s'agrandit au survol et suit le curseur ; elle revient à la normale
     quand le curseur sort, le mode zoom restant activé.
   - Tactile (zoom activé) : toucher l'image puis glisser le doigt pour explorer.
   - Clavier (zoom activé) : image focalisable, flèches pour se déplacer, Échap pour désactiver.
   - L'image haute définition n'est chargée qu'une fois le zoom activé.
   - Changer de photo réinitialise la position sans changer le mode. */
(function () {
  if (window.__neilyZoom) return;
  window.__neilyZoom = true;

  var SCALE = 2.5;
  var HI_WIDTH = 2400;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  // Mode zoom mémorisé par section (survit au re-rendu de la galerie lors d'un changement de variante)
  var modes = {};

  var TXT = {
    on: 'Activer le zoom',
    off: 'Désactiver le zoom',
    hintMouse: 'Déplacez la souris sur l’image pour explorer les détails.',
    hintTouch: 'Faites glisser votre doigt sur l’image pour explorer les détails.',
    hintScroll: 'Désactivez le zoom pour faire défiler normalement.',
  };
  var ICON_ZOOM =
    '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" width="18" height="18"><circle cx="10.5" cy="10.5" r="6.5" fill="none" stroke="currentColor" stroke-width="1.8"/><path d="M15.5 15.5L20 20" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><path class="neily-zoom-toggle__plus" d="M10.5 7.8v5.4M7.8 10.5h5.4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';

  function hiResUrl(img) {
    var src = img.currentSrc || img.src;
    if (!src) return null;
    try {
      var u = new URL(src, window.location.href);
      u.searchParams.set('width', HI_WIDTH);
      return u.toString();
    } catch (e) {
      return null;
    }
  }

  function galleryKey(gallery) {
    return gallery.id || 'gallery';
  }
  function isModeOn(gallery) {
    return !!modes[galleryKey(gallery)];
  }

  function setupItem(item, gallery) {
    if (item.dataset.neilyZoom) return;
    var box = item.querySelector('.product-media-container.media-type-image .product__media');
    var img = box && box.querySelector('img');
    if (!img) return;
    item.dataset.neilyZoom = '1';
    box.classList.add('neily-zoom');

    var state = { on: false, x: 50, y: 50, raf: 0, hiLoaded: false, drag: null };

    function loadHiRes() {
      if (state.hiLoaded) return;
      state.hiLoaded = true;
      var url = hiResUrl(img);
      if (!url) return;
      var pre = new Image();
      pre.decoding = 'async';
      pre.onload = function () {
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = url;
      };
      pre.src = url;
    }
    item._neilyZoomPreload = loadHiRes;

    function render() {
      state.raf = 0;
      img.style.transformOrigin = state.x + '% ' + state.y + '%';
    }
    function schedule() {
      if (!state.raf) state.raf = requestAnimationFrame(render);
    }
    function pointToPct(clientX, clientY) {
      var r = box.getBoundingClientRect();
      if (!r.width || !r.height) return;
      state.x = Math.min(100, Math.max(0, ((clientX - r.left) / r.width) * 100));
      state.y = Math.min(100, Math.max(0, ((clientY - r.top) / r.height) * 100));
    }
    function zoomIn() {
      if (!isModeOn(gallery)) return;
      loadHiRes();
      render();
      if (state.on) return;
      state.on = true;
      box.classList.add('is-zoomed');
      img.style.transform = 'scale(' + SCALE + ')';
    }
    // Retour visuel à l'affichage normal (le mode zoom n'est pas modifié)
    function zoomOut() {
      state.drag = null;
      if (!state.on) return;
      state.on = false;
      box.classList.remove('is-zoomed');
      img.style.transform = '';
      state.x = 50;
      state.y = 50;
      img.style.transformOrigin = '';
    }
    item._neilyZoomOut = zoomOut;
    item._neilyZoomIsOn = function () {
      return state.on;
    };
    item._neilyZoomCancelTap = function () {};
    item._neilyZoomSetFocusable = function (on) {
      if (on) {
        box.setAttribute('tabindex', '0');
        box.setAttribute('role', 'img');
        box.setAttribute(
          'aria-label',
          'Image agrandissable' + (img.alt ? ' : ' + img.alt : '') + '. Flèches pour explorer, Échap pour désactiver le zoom.'
        );
      } else {
        box.removeAttribute('tabindex');
        box.removeAttribute('role');
        box.removeAttribute('aria-label');
      }
    };
    item._neilyZoomSetFocusable(isModeOn(gallery));

    // Souris
    box.addEventListener('pointerenter', function (e) {
      if (e.pointerType !== 'mouse' || !isModeOn(gallery)) return;
      pointToPct(e.clientX, e.clientY);
      zoomIn();
    });
    box.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse' || !isModeOn(gallery)) return;
      pointToPct(e.clientX, e.clientY);
      if (!state.on) zoomIn();
      schedule();
    });
    box.addEventListener('pointerleave', function (e) {
      if (e.pointerType === 'mouse') zoomOut();
    });

    // Tactile : uniquement quand le mode zoom est activé
    box.addEventListener(
      'touchstart',
      function (e) {
        if (!isModeOn(gallery) || e.touches.length !== 1) return;
        var t = e.touches[0];
        if (!state.on) {
          pointToPct(t.clientX, t.clientY);
          zoomIn();
        }
        state.drag = { cx: t.clientX, cy: t.clientY, x: state.x, y: state.y };
      },
      { passive: true }
    );
    box.addEventListener(
      'touchmove',
      function (e) {
        if (!isModeOn(gallery) || !state.on || !state.drag || e.touches.length !== 1) return;
        if (e.cancelable) e.preventDefault();
        var t = e.touches[0];
        var r = box.getBoundingClientRect();
        // Le contenu suit le doigt, comme si on faisait glisser la photo agrandie
        var dx = (((t.clientX - state.drag.cx) / r.width) * 100) / (SCALE - 1);
        var dy = (((t.clientY - state.drag.cy) / r.height) * 100) / (SCALE - 1);
        state.x = Math.min(100, Math.max(0, state.drag.x - dx));
        state.y = Math.min(100, Math.max(0, state.drag.y - dy));
        schedule();
      },
      { passive: false }
    );
    box.addEventListener('touchend', function () {
      state.drag = null;
    });
    box.addEventListener('touchcancel', function () {
      state.drag = null;
    });

    // Clavier (zoom activé)
    box.addEventListener('keydown', function (e) {
      if (!isModeOn(gallery)) return;
      var step = 10;
      if (e.key === 'Escape') {
        e.preventDefault();
        setMode(gallery, false);
        var btn = gallery.querySelector('.neily-zoom-toggle__btn');
        if (btn) btn.focus();
      } else if (/^Arrow/.test(e.key)) {
        e.preventDefault();
        if (!state.on) zoomIn();
        if (e.key === 'ArrowLeft') state.x = Math.max(0, state.x - step);
        if (e.key === 'ArrowRight') state.x = Math.min(100, state.x + step);
        if (e.key === 'ArrowUp') state.y = Math.max(0, state.y - step);
        if (e.key === 'ArrowDown') state.y = Math.min(100, state.y + step);
        schedule();
      }
    });
    box.addEventListener('blur', function () {
      if (!box.matches(':hover')) zoomOut();
    });
  }

  function items(gallery) {
    return Array.prototype.slice.call(gallery.querySelectorAll('[id^="GalleryViewer"] .product__media-item[data-neily-zoom]'));
  }

  function resetAll(gallery) {
    items(gallery).forEach(function (item) {
      if (item._neilyZoomOut) item._neilyZoomOut();
    });
  }

  function activeItem(gallery) {
    var list = gallery.querySelector('[id^="GalleryViewer"] .product__media-list');
    if (!list) return null;
    var all = Array.prototype.slice.call(list.querySelectorAll(':scope > .product__media-item'));
    if (window.matchMedia('(min-width: 750px)').matches) {
      for (var i = 0; i < all.length; i++) if (all[i].classList.contains('is-active')) return all[i];
      return all[0] || null;
    }
    var best = all[0] || null;
    var dist = Infinity;
    all.forEach(function (el) {
      var d = Math.abs(el.offsetLeft - all[0].offsetLeft - list.scrollLeft);
      if (d < dist) {
        dist = d;
        best = el;
      }
    });
    return best;
  }

  function updateToggle(gallery) {
    var wrap = gallery.querySelector('.neily-zoom-toggle');
    if (!wrap) return;
    var on = isModeOn(gallery);
    var btn = wrap.querySelector('.neily-zoom-toggle__btn');
    var label = wrap.querySelector('.neily-zoom-toggle__label');
    var hint = wrap.querySelector('.neily-zoom-toggle__hint');
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.classList.toggle('is-active', on);
    label.textContent = on ? TXT.off : TXT.on;
    if (on) {
      hint.innerHTML = '';
      var p1 = document.createElement('span');
      p1.textContent = finePointer.matches ? TXT.hintMouse : TXT.hintTouch;
      hint.appendChild(p1);
      if (!finePointer.matches) {
        var p2 = document.createElement('span');
        p2.className = 'neily-zoom-toggle__hint-secondary';
        p2.textContent = TXT.hintScroll;
        hint.appendChild(p2);
      }
      hint.hidden = false;
    } else {
      hint.hidden = true;
      hint.textContent = '';
    }
    gallery.classList.toggle('neily-zoom-mode', on);
  }

  function setMode(gallery, on) {
    modes[galleryKey(gallery)] = !!on;
    if (!on) resetAll(gallery);
    items(gallery).forEach(function (item) {
      if (item._neilyZoomSetFocusable) item._neilyZoomSetFocusable(!!on);
    });
    if (on) {
      // Charge la haute définition de la photo affichée dès l'activation
      var it = activeItem(gallery);
      if (it && it._neilyZoomPreload) it._neilyZoomPreload();
    }
    updateToggle(gallery);
  }

  function ensureToggle(gallery) {
    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return;
    if (!items(gallery).length) return;
    var existing = gallery.querySelector(':scope > .neily-zoom-toggle');
    if (existing) return;
    var wrap = document.createElement('div');
    wrap.className = 'neily-zoom-toggle';
    wrap.innerHTML =
      '<button type="button" class="neily-zoom-toggle__btn" aria-pressed="false">' +
      ICON_ZOOM +
      '<span class="neily-zoom-toggle__label"></span></button>' +
      '<p class="neily-zoom-toggle__hint" aria-live="polite" hidden></p>';
    viewer.insertAdjacentElement('afterend', wrap);
    var btn = wrap.querySelector('.neily-zoom-toggle__btn');
    if (viewer.id) btn.setAttribute('aria-controls', viewer.id);
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      setMode(gallery, !isModeOn(gallery));
    });
    updateToggle(gallery);
  }

  function init() {
    document.querySelectorAll('product-info[id^="MainProduct-"] media-gallery').forEach(function (gallery) {
      gallery.querySelectorAll('[id^="GalleryViewer"] .product__media-item').forEach(function (item) {
        setupItem(item, gallery);
      });
      ensureToggle(gallery);
      var viewer = gallery.querySelector('[id^="GalleryViewer"]');
      if (viewer && !viewer.dataset.neilyZoomBound) {
        viewer.dataset.neilyZoomBound = '1';
        viewer.addEventListener('slideChanged', function () {
          resetAll(gallery);
        });
      }
      if (gallery.dataset.neilyZoomBound) return;
      gallery.dataset.neilyZoomBound = '1';
      gallery.addEventListener('click', function (e) {
        if (e.target.closest('[id^="GalleryThumbnails"]')) resetAll(gallery);
      });
    });
  }

  // Exposé pour la navigation de la galerie (neily-gallery-nav.js)
  window.NeilyZoom = {
    isModeOn: function (gallery) {
      return !!gallery && isModeOn(gallery);
    },
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  if (finePointer.addEventListener) {
    finePointer.addEventListener('change', function () {
      document.querySelectorAll('product-info[id^="MainProduct-"] media-gallery').forEach(updateToggle);
    });
  }
  // Les médias sont re-rendus lors d'un changement de variante
  var mo = new MutationObserver(init);
  document.querySelectorAll('product-info[id^="MainProduct-"]').forEach(function (el) {
    mo.observe(el, { childList: true, subtree: true });
  });
  document.addEventListener('shopify:section:load', init);
})();
